module.exports = __webpack_public_path__ + "static/media/rapun.4bdab690.mp4";